var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 145.5,
    height: 145.5,
    viewBox: "0 0 145.5 145.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 21.35,
    y1: 124.15,
    x2: 124.15,
    y2: 21.35,
    gradientTransform: "translate(72.75 -30.13) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9748a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d163ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 42.23,
    y1: 108.28,
    x2: 103.27,
    y2: 47.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edbede"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.75,
    cy: 72.75,
    r: 72.75,
    transform: "translate(-30.13 72.75) rotate(-45)",
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.42,47.81A19.58,19.58,0,0,0,78,34.73H49.76A19.57,19.57,0,0,0,30.21,54.28V95.22a2.49,2.49,0,0,0,1.54,2.31,2.44,2.44,0,0,0,1,.19A2.48,2.48,0,0,0,34.47,97L45.79,85.67h3.29a19.51,19.51,0,0,0,18.43,13h32.2L111,110a2.5,2.5,0,0,0,1.77.73,2.44,2.44,0,0,0,1-.19,2.5,2.5,0,0,0,1.55-2.31V67.33A19.57,19.57,0,0,0,96.42,47.81ZM44.76,80.67A2.51,2.51,0,0,0,43,81.4l-7.78,7.79V54.28A14.57,14.57,0,0,1,49.76,39.73H78A14.57,14.57,0,0,1,92.54,54.28V66.12A14.57,14.57,0,0,1,78,80.67Zm65.54,21.57-7.79-7.79a2.51,2.51,0,0,0-1.77-.73H67.51a14.73,14.73,0,0,1-13-8H78A19.57,19.57,0,0,0,97.54,66.12V54.28c0-.47,0-.93-.07-1.39A14.58,14.58,0,0,1,110.3,67.33ZM44.76,54.36a2.5,2.5,0,0,1,2.5-2.5H80.49a2.5,2.5,0,0,1,0,5H47.26A2.5,2.5,0,0,1,44.76,54.36ZM72.33,66a2.5,2.5,0,0,1-2.5,2.5H47.26a2.5,2.5,0,0,1,0-5H69.83A2.5,2.5,0,0,1,72.33,66Z",
    fill: "url(#b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.b5bf9bba67c8215bd3a234ead60eaab6.svg";
export { ForwardRef as ReactComponent };